import React from 'react';
import PropTypes from 'prop-types';

import {Stack, Typography, Box} from 'views/components';
import {Translate, translate} from 'views/module';

const Content = (props) => {
  const clientPaymentPlan = props.clientPaymentPlan;
  const setEditMode = props.setEditMode;

  const billingPeriod = clientPaymentPlan?.billingPeriod || 'WEEKLY';

  return (
    <Stack
      direction={'column'}
      sx={{
        'display': 'flex',
        '&:hover': {
          cursor: 'pointer',
        },
      }}
      onClick={setEditMode}
    >
      <Box sx={{mr: 1}}>
        <Typography
          sx={{
            fontSize: '10px',
          }}
        >
          <Translate
            expression={'client.ClientDetail.Payment.PaymentPlan.BillingPeriodTitle'}
          />
        </Typography>
      </Box>
      <Box>
        <Typography
          sx={{
            fontWeight: 600,
            fontSize: '18px',
          }}
        >
          {translate(`client.ClientDetail.Payment.PaymentPlan.BillingPeriod.Options.${billingPeriod}`)}
        </Typography>
      </Box>
    </Stack>
  );
};

Content.propTypes = {
  clientPaymentPlan: PropTypes.object.isRequired,
  setEditMode: PropTypes.func.isRequired,
};
export default React.memo(Content);
